<span class="task-plus__btn">
  <svg viewBox="0 0 1024 1024">
    <path
      d="M409.6 409.6v-307.671c0-55.269 45.846-101.929 102.4-101.929 56.948 0 102.4 45.635 102.4 101.929v307.671h307.671c55.269 0 101.929 45.846 101.929 102.4 0 56.948-45.635 102.4-101.929 102.4h-307.671v307.671c0 55.269-45.846 101.929-102.4 101.929-56.948 0-102.4-45.635-102.4-101.929v-307.671h-307.671c-55.269 0-101.929-45.846-101.929-102.4 0-56.948 45.635-102.4 101.929-102.4h307.671z"
    ></path>
  </svg>
</span>
